import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.Wallets.DropdownMenu', {
    addCurrency: 'Add currency',
    bankStatementReport: 'Bank statement report',
    transactions: 'Transactions',
});
